import { SvgIcon, SvgIconProps } from "@mui/material";

export const SortingUpArrowIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <rect
        width="20"
        height="20"
        y="20"
        fill="#E7E9FE"
        rx="10"
        transform="rotate(-90 0 20)"
      />
      <path
        stroke="#5563F5"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M10 4.167v11.666m4.167-7.5L10 4.167M5.833 8.333 10 4.167"
      />
    </svg>
  </SvgIcon>
);
